export const COURSE_ACTION_TYPE = {
    getStartedCourseFetchingStart:'getStartedCourseFetchingStart',
    getStartedCourseFetchingSuccess:'getStartedCourseFetchingSuccess',
    getStartedCourseIdle:'getStartedCourseIdle',
};
